import React from 'react';
import './StepsSection.css';

const StepsSection: React.FC = () => {
  return (
    <section className="steps-section">
      <div className="steps-container">
        <div className="steps-header">
          <h2 className="steps-title">Humanize Texto de IA em 3 Passos Simples</h2>
          <p className="steps-subtitle">Perfeito para ensaios, trabalhos, posts de blog e artigos de pesquisa</p>
        </div>

        <div className="steps-grid">
          <div className="step-card">
            <div className="step-visual">
              <div className="step-mockup step-1-mockup">
                <div className="mockup-header">
                  <span className="mockup-title">Your Text</span>
                </div>
                <div className="mockup-content">
                  <div className="mockup-text-line"></div>
                  <div className="mockup-text-line short"></div>
                  <div className="mockup-text-line"></div>
                  <div className="paste-btn-mock">Cole seu texto</div>
                </div>
              </div>
            </div>
            <div className="step-info">
              <div className="step-number">PASSO 1</div>
              <h3 className="step-title">Cole Seu Texto</h3>
              <p className="step-description">
                Cole qualquer conteúdo — trabalho de casa, tarefa ou rascunho gerado por IA
              </p>
            </div>
          </div>

          <div className="step-card">
            <div className="step-visual">
              <div className="step-mockup step-2-mockup">
                <div className="mockup-header">
                  <span className="mockup-title">Results</span>
                </div>
                <div className="gauge-container">
                  <div className="gauge-circle">
                    <span className="gauge-percentage">50%</span>
                  </div>
                  <div className="gauge-bar"></div>
                </div>
                <div className="detection-icons">
                  <span className="detector-icon">✓ Writer</span>
                  <span className="detector-icon">✓ OpenAI</span>
                  <span className="detector-icon">✓ GPT</span>
                  <span className="detector-icon">✓ Claude</span>
                  <span className="detector-icon">✓ Gemini</span>
                </div>
                <div className="analysis-text">AI Analysis Complete</div>
              </div>
            </div>
            <div className="step-info">
              <div className="step-number">PASSO 2</div>
              <h3 className="step-title">Verifique Pontuação IA</h3>
              <p className="step-description">
                Veja o quanto do seu texto é considerado escrito por humanos
              </p>
            </div>
          </div>

          <div className="step-card">
            <div className="step-visual">
              <div className="step-mockup step-3-mockup">
                <div className="humanize-btn-large">
                  Humanizar
                </div>
                <div className="cursor-pointer">↑</div>
              </div>
            </div>
            <div className="step-info">
              <div className="step-number">PASSO 3</div>
              <h3 className="step-title">Humanizar</h3>
              <p className="step-description">
                Aprimore seu texto para soar mais natural e autêntico, com qualidade profissional
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StepsSection;